import { useEffect } from "react";
import { useOrdersStore } from "../stores/orders/orders-store";

interface UseAuthStateProps {
  userDetails: any;
}

export const useAuthState = ({ userDetails }: UseAuthStateProps) => {
  const { reset } = useOrdersStore();

  useEffect(() => {
    // Clear store when user is not authenticated or when userDetails is null/undefined
    if (!userDetails || !userDetails?.token || !userDetails?.isAuthenticated) {
      console.log("Authentication state changed - clearing orders store");
      reset();
    }
  }, [userDetails, reset]);

  // Listen for storage events (in case logout happens in another tab or window)
  useEffect(() => {
    const handleStorageChange = (e: StorageEvent) => {
      if (e.key === "businessAccessToken" && !e.newValue) {
        console.log("Token removed from storage - clearing orders store");
        reset();
      }
    };

    const handleBeforeUnload = () => {
      // Clear store when page is being unloaded (logout scenario)
      console.log("Page unloading - clearing orders store");
      reset();
    };

    window.addEventListener("storage", handleStorageChange);
    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [reset]);
};
